/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_TitleInputs */

const zh_course_title = /** @type {(inputs: Course_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程`)
};

const en_course_title = /** @type {(inputs: Course_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courses`)
};

const es_course_title = /** @type {(inputs: Course_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cursos`)
};

/**
* | output |
* | --- |
* | "Courses" |
*
* @param {Course_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const course_title = /** @type {((inputs?: Course_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_title(inputs)
	if (locale === "en") return en_course_title(inputs)
	return es_course_title(inputs)
});